import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import moment from 'moment'
import wx from 'weixin-js-sdk'
import { API_BASE_URL } from '../../../../../common/utils/commonUrl'
import http from '../../../../../common/utils/http'
import memberApi from '../../../../../api/wx-member/member/member'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      radio: null,
      detailInfo: '',
      commodityDetails: null,
      exchangeValue: null,
      id: "",
      payType: null,
      pay_total: ""
    }
  },
  methods: {
    async getAddress () {
      let vm = this
      const result = await memberApi.getWXSignature({ url: location.href.split('#')[0] })
      wx.config({
        debug: false,
        appId: result.appId, // 必填,公众号的唯一标识
        timestamp: result.timestamp, // 必填,生成签名的时间戳
        nonceStr: result.nonceStr, // 必填,生成签名的随机串
        signature: result.signature, // 必填,签名
        jsApiList: ['scanQRCode', 'openAddress'] // 必填,需要使用的JS接口列表
      });
      wx.ready(function () {
        // 在这里调用 API
        wx.checkJsApi({
          jsApiList: ['openAddress'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function (res1) {
            wx.openAddress({
              success: function (res) {
                var userName = res.userName; // 收货人姓名
                var postalCode = res.postalCode; // 邮编
                var provinceName = res.provinceName; // 国标收货地址第一级地址（省）
                var cityName = res.cityName; // 国标收货地址第二级地址（市）
                var countryName = res.countryName; // 国标收货地址第三级地址（国家）
                var detailInfo = res.detailInfo; // 详细收货地址信息
                var nationalCode = res.nationalCode; // 收货地址国家码
                var telNumber = res.telNumber; // 收货人手机号码

                vm.detailInfo = userName + ' ' + telNumber + ' ' + provinceName + ' ' + cityName + ' ' + countryName + ' ' + detailInfo
              }
            });
          }
        });
      })
    },
    //商品详情
    getCommodityDetails () {
      http.get(`${API_BASE_URL}api/wxoa/pmall/wxoaPmall/getCommodityDetails?id=${this.id}`).then(
        res => {
          this.commodityDetails = res.data.data
        }
      )
    },
    getPointsRedeemOrderExchangeValue () {
      http.get(`${API_BASE_URL}api/wxoa/pmall/wxoaPmall/getPointsRedeemOrderExchangeValue?id=${this.id}`).then(
        res => {
          this.exchangeValue = res.data.data
        }
      )
    },
    submit () {
      if (this.exchangeValue.pointsPrompt && !this.exchangeValue.pointsAndAmount && !this.exchangeValue.amount) {
        this.$message({
          message: '积分余额不足',
          type: 'warning'
        })
        return
      };
      if (!this.payType) {
        this.$message({
          message: '请选择支付方式',
          type: 'warning'
        })
        return
      }
      const data = {
        commodityId: this.id,  //商品id
        payType: this.payType  //1000 积分兑换  3000微信支付  4000混合支付   prepay
      };
      http.post(`${API_BASE_URL}api/wxoa/pmall/wxoaPmall/createPointsRedeemOrder`, data).then(
        async res => {
          if (this.payType == 1000) {
            if (res.data.code && res.data.code === 'SUCC-0000') {
              this.$message({
                message: '支付成功！',
                type: 'success'
              })
              this.$router.push({
                path: RoutePathConstants.POINTS_MAIL_HOME_PAGE,
              })
            } else {
              this.$message.error('支付失败！')
            }
          } else {
            let prepayResponse = res.data
            if (prepayResponse.code === ReturnCodesConstants.SUCCESS_CODE) {
              const chooseWXPayMap = prepayResponse.data.prepayResponseInfo.chooseWXPayMap
              if (!chooseWXPayMap) {
                this.$message.error('预支付参数有问题')
                return
              }
              const result = await memberApi.getWXSignature({ url: location.href.split('#')[0] })
              const vm = this
              wx.config({
                debug: false,
                appId: result.appId, // 必填,公众号的唯一标识
                timestamp: result.timestamp, // 必填,生成签名的时间戳
                nonceStr: result.nonceStr, // 必填,生成签名的随机串
                signature: result.signature, // 必填,签名
                jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填,需要使用的JS接口列表
              })
              wx.ready(() => {
                wx.checkJsApi({
                  jsApiList: ['chooseWXPay'],
                  success: function (res) {
                    wx.chooseWXPay({
                      appId: result.appId,
                      timestamp: chooseWXPayMap.timeStamp,
                      nonceStr: chooseWXPayMap.nonceStr,
                      package: chooseWXPayMap.package,
                      signType: chooseWXPayMap.signType,
                      paySign: chooseWXPayMap.paySign,
                      success: function (res) {
                        if (res.errMsg === 'chooseWXPay:ok') {
                          vm.$router.push({
                            path: RoutePathConstants.POINTS_MAIL_HOME_PAGE
                          })
                          return
                        }
                        vm.$message.error('支付失败', res.errMsg)
                      },
                      cancel: function (res) {
                        console.log('取消支付', res)
                        vm.$message.error('取消支付')
                      },
                      fail: function (res) {
                        console.log('支付失败', res)
                        vm.$message.error('支付失败')
                      }
                    })
                  },
                  fail: function (res) {
                    alert('fail' + res)
                  }
                })
              })
              /* 处理失败验证 */
              wx.error(function (res) {
                // config 信息验证失败会执行error函数,如签名过期导致验证失败,
                // 具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
                alert('配置验证失败: ' + res.errMsg)
              })
            } else {
              this.$message.error(prepayResponse.data.message)
            }
          }

        }
      ).catch((err) => {
        console.error('支付失败', err)
        this.$message.error('支付失败！')
      })
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.getCommodityDetails()
    this.getPointsRedeemOrderExchangeValue()
  },
  watch: {
    payType () {
      if (this.payType == 3000) {
        this.pay_total = '￥' + this.exchangeValue.amount
      };
      if (this.payType == 1000) {
        this.pay_total = this.exchangeValue.points + "积分"
      };
      if (this.payType == 4000) {
        this.pay_total = this.exchangeValue.pointsAndAmount
      };
    },
  },
  computed: {
    ...mapState('productDetailsModule', ['productDetailsInfo']),
    productDetails () {
      return this.commodityDetails
    },
    productDetailsCodeToFileIds () {
      if (!this.productDetailsInfo || !this.productDetailsInfo.codeToFileIds) {
        return {}
      }
      return this.productDetailsInfo.codeToFileIds
    },
    productDetailsFileIds () {
      return code => {
        if (!this.productDetailsCodeToFileIds[code] ||
          !this.productDetailsCodeToFileIds[code].length) {
          return []
        }

        return this.productDetailsInfo.codeToFileIds[code]
      }
    },
    productImages () {
      return this.productDetailsFileIds('details')
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-details/views/product-pay.js